import OSmsModalStandard from './o-sms-modal-standard';

export default OSmsModalStandard;